var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IconBase',{attrs:{"icon-name":"current"}},[_c('path',{staticClass:"grayStroke",attrs:{"d":"M7,20 16,10"}}),_c('circle',{staticClass:"whiteFill blueStroke",attrs:{"cx":"16","cy":"10","r":"3"}})])}
var staticRenderFns = []

export { render, staticRenderFns }